import CloudOffOutlinedIcon from "@mui/icons-material/CloudOffOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { captionSx, mono, wireButtonSx } from "../styles/mainStyles";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { slidingElevatedCardSx } from "../lib/appearance";

/**
 * Full-width empty / error panel for the library feed.
 * @param {'offline'|'error'} variant
 */
export default function LibraryFeedState({ variant, title, body, actionLabel, onAction }) {
    const { tokens } = useSlidingAppearance();
    const Icon = variant === "offline" ? CloudOffOutlinedIcon : ErrorOutlineOutlinedIcon;

    return (
        <Box
            role={variant === "offline" ? "status" : "alert"}
            sx={{
                textAlign: "center",
                py: 4,
                px: 2,
                borderRadius: "16px",
                ...slidingElevatedCardSx(tokens),
            }}
        >
            <Icon sx={{ fontSize: 40, color: tokens.iconMuted, mb: 1.5 }} aria-hidden />
            <Typography
                sx={{
                    fontFamily: mono,
                    fontSize: "0.95rem",
                    fontWeight: 700,
                    mb: 1,
                    lineHeight: 1.35,
                    color: tokens.text,
                }}
            >
                {title}
            </Typography>
            <Typography
                sx={{ ...captionSx, color: tokens.textMuted, mb: 2, maxWidth: 280, mx: "auto", lineHeight: 1.5 }}
            >
                {body}
            </Typography>
            {onAction ? (
                <Button type="button" onClick={onAction} sx={{ ...wireButtonSx, maxWidth: 240, mx: "auto" }}>
                    {actionLabel}
                </Button>
            ) : null}
        </Box>
    );
}
